//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import {createNamespacedHelpers} from 'vuex';
import {clearAuthorization, xAjaxJson} from "../../../plugins/MercuryBaseLib";
import {getCookie, COOKIE_NAME_LOCALE, setCookie} from "../../../plugins/MercuryBaseUtils";


const baseHelper = createNamespacedHelpers('base');

export default {
  name: 'mp-app-bar',
  props: {
    logo: {
      type: Object,
      default: () => ({})
    },
    profile: {
      type: Object,
      default: () => ({})
    }
  },
  data: function () {
    return {
      theme: false,
      themeLabel: 'Light',
      locale: 'en',
      dialog: {
        passwordChange: {
          visible: false,
        }
      }
    };
  },
  computed: {
    ...baseHelper.mapGetters([
      'getUser'
    ])
  },
  watch: {
    theme: {
      handler(isDark) {
        this.$vuetify.theme.isDark = isDark;
        if (isDark) {
          setCookie('theme', 'black', 30);
          document.body.classList.add("ubcs-theme-dark");
          this.themeLabel = 'Dark';
        } else {
          setCookie('theme', null, 30);
          document.body.classList.remove("ubcs-theme-dark");
          this.themeLabel = 'Light';
        }
      }
    }
  },
  created() {
    if (getCookie('theme') === 'black') {
      this.$vuetify.theme.isDark = true;
      this.theme = true;
      this.themeLabel = 'Dark';
      document.body.classList.add("ubcs-theme-dark");
    }
    let locale = getCookie(COOKIE_NAME_LOCALE);
    if (!locale) {
      locale = 'en';
      setCookie(COOKIE_NAME_LOCALE, locale, 30)
    }

    this.locale = locale
    this.$i18n.locale = locale
  },
  methods: {
    changeLocale: function (locale) {
      this.locale = locale
      this.$i18n.locale = locale
      setCookie(COOKIE_NAME_LOCALE, locale, 30)
      xAjaxJson({url: '/i18n?lang=' + locale, usePrefixUrl: true}).then(() => {
        //location.reload();//Vu
      });
    },
    logout: function () {
      clearAuthorization();
      location.href = '/login.html';
    }
  }
}

